module.exports = __webpack_public_path__ + "img/page08.e3040951.gif";